import React, { } from "react";
import BrandComponents from "../Brand/BrandComponents";


function SupplierTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Company Name", field: "companyname" },
    { label: "Contact Person", field: "contactperson" },
    { label: "Contact No.", field: "contactno" },
    { label: "Email", field: "email" },
    { label: "GST No.", field: "gstno" },
    { label: "Action", field: "action" },

  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"SUPPLIER"}
        apiField={"supplier"}
        addButton={"+ ADD"}
        createRoute={"/supplierCreate"}
        updateRoute={"/supplierView"}
        viewRoute={"/supplierView"}
      />
    </div>
  );
}

export default SupplierTable;
